<template>
	<!-- 打印報表 -->
	<div style="width: 1200px;">
		<div style="float: left;">
		<!--<img src="../assets/logo.jpg"></img>-->
			</div>
			<div style="float: left;padding-top: 20px;">
				<div>
					<!--NAME：<el-input v-model="jobOrderForms.printName" clearable style="width: 150px;line-height: 20px;"></el-input>&nbsp;-->&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					<span>工作單號：{{jobOrderForms.jobNo}}</span>
					<span style="padding-left: 40px;">客戶：{{jobOrderForms.custNo}}</span>
					<span style="padding-left: 40px;">姓名：{{jobOrderForms.custName}}</span>
					<span style="padding-left: 40px;">日期：{{getIssueDate(this.jobOrderForms.startDate)}}</span>
                </div>
				<div style="margin-top: 10px;">
					<!--日期：{{getIssueDate(this.jobOrderForms.startDate)}}-->
                    <!--<el-date-picker
                            v-model="jobOrderForms.printDate"
                            type="date"
                            placeholder="選擇日期"
                            style="width: 150px;"
                    >
                    </el-date-picker>-->

					<span style="padding-left: 40px;">真實箱：{{this.jobJsonList.length}}</span>
					<span style="padding-left: 68px;">真實板：{{this.jobPalletList.length}}</span>
					<span style="padding-left: 60px;">目的地：{{jobOrderForms.dest}}</span>
                </div>
			</div>
		<div style="clear: both;">
			
			<div style="float: left;margin-top: 10px;">
				<table class="leftTable" border="1" cellspacing="0" cellpadding="0" style="clear: both;">
				<!--	<tr v-for="n in forNum">
						<td v-for="(value,key) in jobJsonList" :id="key">
						&lt;!&ndash;<span v-if="dateMap.get((n-1)*10+j)">{{(n-1)*10+j}}-{{dateMap.get((n-1)*10+j)}}</span>&ndash;&gt;
						&lt;!&ndash;<input style="width: 70px; float: right; margin-right: 5px;"></input>&ndash;&gt;
						</td>
					</tr>-->
					<div v-for="n in jobTrcount">
						<tr>
							<td valign="middle" v-for="value in jobJsonList2[n-1]" style="color: #f3f3f3;background-color: #4B78FF;">
								{{value}}
							</td>
						</tr>
						<tr>
							<td valign="middle" v-for="(item,key) in jobPalletNumList[n-1]" @click="boxClick(item)">
								<span>{{item.pallet}}</span>
							</td>
						</tr>
					</div>
					<!-- <tr v-for="n in jobTrcount">
                     <!--<td v-for="value in jobJsonList2[n-1]">
                             {{value.box}}-{{value.pallet}}
                             </td>-->
					<!-- 	<td v-for="(value,key) in jobJsonList" :id="key">
                         {{value.box}}-{{value.pallet}}
						</td>
				       </tr>-->
				</table>
				</div>
				<div style="float: left; margin-left: 30px; margin-top: 10px;"  >
				
				<table class="leftTable" border="1" cellspacing="0" cellpadding="0" >
					<div v-for="(value,key) in jobPalletList" :id="key">
						<tr>
							<td valign="middle">PALLET#</td>
							<td valign="middle" style="width: 150px;height: 30px;">DIMENSION(CM)</td>
							<td valign="middle">CBM</td>
							<td valign="middle">PKGS.</td>
						</tr>
						<tr>
							<td valign="middle">{{value.pallet}}</td>
							<td valign="middle"><input type="text" v-model="value.cmLong" style="width: 45px"/>
							<input type="text" v-model="value.cmWide" style="width: 45px"/>
							<input type="text" v-model="value.cmHigh" style="width: 45px"/></td>
							<td valign="middle"><input type="text" v-model="value.cbm" style="width: 95px"/></td>
							<td valign="middle"><input type="text" v-model="value.pkgS" style="width: 95px"/></td>
						</tr>
						<tr>
							<td valign="middle">箱號</td>
							<td style="width: 150px;height: 30px;text-align:left;" colspan="3" valign="middle">{{value.boxStr}}</td>
						</tr>
					</div>
					</table>
					<div style="height: 10px;"></div>
					<el-button size="small" type="primary" style="float: left;margin-bottom: 5px;margin-left: 15px;" @click="jobPallSave()"> 保 存 </el-button>
					<el-button size="small" type="primary" style="float: left;margin-bottom: 5px;margin-left: 15px;" @click="goBack">返 回</el-button>
				</div>
		</div>


		<!-- 附件上传页面-->
		<el-dialog :title="dialogFileName" :visible.sync="dialogFileVisible" width="400px" :close-on-click-modal=false>
			<el-form  :model="boxFile"  :rules="boxFileRules" ref="boxFile" label-width="100px" size="small">
				<el-row :gutter="0">
					<el-col :span="24">
						<el-form-item label="箱號" prop="box">
							 {{boxFile.box}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="0">
					<el-col :span="24">
						<el-form-item label="卡板號" prop="pallet">
						<el-input v-model="boxFile.pallet" clearable style="width: 150px;line-height: 20px;"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="boxSave" :loading="addEidtloading">{{$t('m.b_save')}}</el-button>
				<el-button @click="dialogFileVisible = false">{{$t('m.b_cancel')}}</el-button>

			</div>
		</el-dialog>
	 </div>
	
</template>

<script>
    import {getJobJsonList,getJobPalletList,updateJobPallet,getJobRecord,updateJobPalletPrint} from '../api/api'
	export default {
	    data() {
			return {
                pickerOptions0:{
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
				titleTxt:["PALLET#","DIMENSION(CM)","CBM","PKGS."],
                acctId:'',
                acctItemId:'',
                jobJsonList:[],
                jobPalletList:[],
				jobJsonList2:[],//变为2维数组
                jobJsonNumList:[],//数字数组

                jobPalletNumList:[],//版号数组
				jobTrcount:0,
				jobForm:{
				    id:'',
                    jobId:'',
				},
				forNum:0,
                dateMap:{},
                /*printName:'',
                printDate:new Date(),*/
                jobOrderForms:{
                    jobNo:'',
                    printName:'',
                    printDate:'',
                    startDate:''
                },
                dialogFileVisible:false,
                dialogFileName:'',
                addEidtloading:false,
                boxFile:{
                    box:'',
                    pallet:'',
                    jobId:'',
                    boxOldId:'',
                    palletOldId:''
                },
                boxFileRules: {
                    pallet:[
                        {required: false, validator: function (rule, value, callback) {
                            var reg = /^[0-9]+$/;
                            if (value != "" && value != null) {
                                if (!reg.test(value)) {
                                    callback(new Error('請輸入數字！'));
                                }
                            }
                            callback();
                        }, trigger: 'blur'
                        }
                    ],
                },
				}
			},
        methods: {
            getIssueDate(value){
                if(value!=''|| value!=0) {
                    var d = new Date(value);
                    var m = d.getMonth() + 1;
                    return d.getFullYear() + '-' + m + '-' + d.getDate();
                }
            },
            boxClick(item){
            this.boxFile.box=item.index;
            this.boxFile.pallet=item.pallet;
            this.boxFile.boxOldId=item.boxOldId;
            this.boxFile.palletOldId=item.palletOldId;
            this.boxFile.jobId=this.acctId;
            this.dialogFileVisible=true;
            this.addEidtloading=false;
            this.dialogFileName="編輯卡板箱號";
			},
            boxSave(){
                this.$refs.boxFile.validate((valid) => {
					if (valid) {
                      /*  this.$confirm("你確定要編輯箱號為" + this.boxFile.box + "的卡板號嗎？", this.$t('m.m_info'), {
                            cancelButtonText: this.$t('m.b_cancel'),
                            confirmButtonText: this.$t('m.t_confirm'),
                            type: 'warning'
                        }).then(() => {*/
                            this.addEidtloading = true;
                            var params = Object.assign({}, this.boxFile);
                            updateJobPalletPrint(params).then(data => {
                                let {errcode, errmsg} = data.data;
                                if (errcode == 200) {
                                    this.$message.success("編輯成功！");
                                    this.dialogFileVisible = false;
                                    this.addEidtloading = false;
                                    this.queryOneAcctRec(this.acctId,this.acctItemId);
                                } else {
                                    this.$message.error("編輯失敗！");
                                }
                            });
                        /*})*/
                    }
                });
			},
            jobPallSave(){
                this.jobForm.jobId=this.acctId;
                var params = Object.assign({}, this.jobForm);
                params.printName=this.jobOrderForms.printName;
                params.printDate = Math.round(new Date(this.jobOrderForms.printDate).getTime() / 1000);
                var idList = [];
                var palletList = [];
                var pkgSList=[];
                var cbmList = [];
                var cmLongList = [];
                var cmWideList = [];
                var cmHighList = [];

                this.jobPalletList.forEach((v, i) => idList[i] = v.id);
                this.jobPalletList.forEach((v, i) => palletList[i] = v.pallet);
                this.jobPalletList.forEach((v, i) => pkgSList[i] = v.pkgS);
                this.jobPalletList.forEach((v, i) => cbmList[i] = v.cbm);
                this.jobPalletList.forEach((v, i) => cmLongList[i] = v.cmLong);
                this.jobPalletList.forEach((v, i) => cmWideList[i] = v.cmWide);
                this.jobPalletList.forEach((v, i) => cmHighList[i] = v.cmHigh);

                params.idList = idList;
                params.palletList = palletList;
                params.pkgSList = pkgSList;
                params.cbmList = cbmList;
                params.cmLongList = cmLongList;
                params.cmWideList = cmWideList;
                params.cmHighList = cmHighList;
                updateJobPallet(params).then(data => {
                    let {errcode, errmsg} = data.data;
                    if (errcode == 200) {
                        this.$message.success("修改成功");
                        this.resetForm("jobForm");
                        this.acctId = '';
                        this.acctItemId = '';
                        this.jobJsonList=[];
                        this.jobJsonNumList=[],//数字数组
						this.jobPalletNumList=[],//版号数组
                        this.jobTrcount=0;
                        this.$router.push({
                            name: '工作單',
                            params: {str: new Date().getTime()}
                        })
                        this.$store.commit("closeTab", 'jobPrint');
                    } else {
                        this.$message.error("修改失败！");
                    }
                },);
            }, goBack(){
                this.acctId = '';
                this.acctItemId = '';
                this.jobJsonList=[];
                this.jobJsonNumList=[],//数字数组
                this.jobPalletNumList=[],//版号数
                this.jobTrcount=0;
                this.$router.push({
                    name:'工作單',
                    params:{str:new Date().getTime()}
                })
                this.$store.commit("closeTab","jobPrint");
            },
            resetForm(formName){
                if (this.$refs[formName] !== undefined) {
                    this.$refs[formName].resetFields();
                }
            },
            getJobParams(){
                if (this.acctId == '') {
                    this.acctId = this.$route.params.jobId;
                    this.acctItemId = this.$route.params.id;
                    if (this.acctId != '' || this.acctId != undefined) {
                        this.queryOneAcctRec(this.acctId,this.acctItemId);
                    }
                }
                if (this.acctId != this.$route.params.jobId && this.$route.params.jobId != undefined) {
                    this.acctId = this.$route.params.jobId;
                    this.acctItemId = this.$route.params.id;
                    this.queryOneAcctRec(this.acctId,this.acctItemId);
                }
            },
            queryOneAcctRec(acctId,acctItemId){
                getJobRecord(acctItemId).then(data => {
                    let item = data.data;
                    if (item.data[0] != null) {
                        Object.assign(this.jobOrderForms, item.data[0]);
                        if (item.data[0].printDate == 0 || item.data[0].printDate==null) {
                            this.jobOrderForms.printDate = new Date();
                        } else {
                            this.jobOrderForms.printDate = new Date(item.data[0].printDate * 1000);
                        }
                        if (item.data[0].startDate == 0 || item.data[0].startDate==null) {
                            this.jobOrderForms.startDate = new Date();
                        } else {
                            this.jobOrderForms.startDate = new Date(item.data[0].startDate * 1000);
                        }
                    }
                });
                //this.jobOrderForms.printDate=new Date();
                this.jobPalletList=[];
                var params={jobId:acctId};
                getJobPalletList(params).then(data => {
                let {data:res={}}=data;
                 this.jobPalletList=res.data;
                });
                this.jobTrcount=0;
                this.jobJsonList=[];
                this.jobJsonNumList=[],//数字数组
                this.jobPalletNumList=[],//版号数组

				getJobJsonList(params).then(data => {
					let {data:res={}}=data;
					this.jobJsonList=res.data;
					if(this.jobJsonList.length>0){
                    this.jobTrcount=this.jobJsonList[0].number;
				/*	this.jobTrcount=Math.ceil(this.jobJsonList.length/10);//这个是多少行
                    const iconsArr = []; // 声明数组
                    this.jobJsonList.forEach((item, index) => {
                    const page = Math.floor(index / 10); // 计算该元素为第几个素组内
                    if (!iconsArr[page]) { // 判断是否存在
                      iconsArr[page] = [];
                    }
                    iconsArr[page].push(item);
                  });
					this.jobJsonList2=iconsArr;*/

					for (var i=0;i<this.jobTrcount*10;i++){
						this.jobJsonNumList.push((i+1));
					}
					const iconsArr = []; // 声明数组
					this.jobJsonNumList.forEach((item, index) => {
						const page = Math.floor(index / 10); // 计算该元素为第几个素组内
						if (!iconsArr[page]) { // 判断是否存在
							iconsArr[page] = [];
						}
						iconsArr[page].push(item);
					});
					this.jobJsonList2=iconsArr;

					const iconsArr1 = []; // 声明数组
					this.jobPalletNumList=[];
					this.jobJsonNumList.forEach((item, index) => {
					const page = Math.floor(index / 10); // 计算该元素为第几个素组内
					if (!iconsArr1[page]) { // 判断是否存在
						iconsArr1[page] = [];
					}
					var boxN=0;
                    var boxId=0;
                    var palletId=0;
					for(var j=0;j<this.jobJsonList.length;j++){
					    if(item==this.jobJsonList[j].box){
                            boxN=this.jobJsonList[j].pallet;
                            boxId=this.jobJsonList[j].boxOldId;
                            palletId=this.jobJsonList[j].palletOldId;
                            break;
						}
					}

					if(boxN!=0){
                        this.boxName={
                            index:item,
                            pallet:boxN,
                            boxOldId:boxId,
                            palletOldId:palletId
                        },
                        iconsArr1[page].push(this.boxName);
                    }else{
                        this.boxName={
                            index:item,
                            pallet:"",
                            boxOldId:"",
                            palletOldId:""
                        },
                        iconsArr1[page].push(this.boxName);
					}
					});
                	this.jobPalletNumList=iconsArr1;
                    }
				});
            }
        },
        activated(){
            this.getJobParams();
        },
}
</script>

<style>
	.leftTable td
	{
		width: 60px;
		height: 30px;
		text-align:center;
	}
	.rightTable td
	{
		width: 90px;
		height: 30px;
		padding-top: 3px;
	}
</style>



// WEBPACK FOOTER //
// src/views/JobPrinting.vue